import * as XLSX from 'xlsx'
import { formatDate } from '../../../lib/helpers'
import { getReferees } from '../../../lib/api'

const CSV_HEADERS = [
    'ID sudije',
    'Ime i prezime',
    'Email',
    'Kontakt telefon',
]

const buildRows = async (filterParams, searchInputId) => {
    const search = document.getElementById(searchInputId)
    const [given_name, family_name] = (search?.value || '').split(' ')

    const { allReferees } = await getReferees(
        [],
        { given_name, family_name },
        filterParams,
        1,
        true,
        false
    )

    return (allReferees || []).map((r) => {
        const attrs = r?.attributes
        return [
            attrs?.uuid || '-',
            `${attrs?.person_info?.given_name || ''} ${attrs?.person_info?.family_name || ''}`.trim() || '-',
            attrs?.person_info?.email || '-',
            attrs?.person_info?.phone || '-',
        ]
    })
}

const filename = (ext, count) =>
    `Sudije - Ukupno-${count}, ${formatDate(new Date()).slice(0, -1)}.${ext}`

export const exportExcel = async (filterParams, searchInputId, setIsLoading) => {
    setIsLoading(true)
    try {
        const rows = await buildRows(filterParams, searchInputId)
        const worksheet = XLSX.utils.aoa_to_sheet([CSV_HEADERS, ...rows])
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sudije')
        XLSX.writeFile(workbook, filename('xlsx', rows.length))
    } finally {
        setIsLoading(false)
    }
}

export const exportCSV = async (filterParams, searchInputId, setIsLoading) => {
    setIsLoading(true)
    try {
        const rows = await buildRows(filterParams, searchInputId)
        const data = [CSV_HEADERS, ...rows]
        const csvContent = data
            .map((row) =>
                row
                    .map((cell) => `"${String(cell).replace(/"/g, '""')}"`)
                    .join(',')
            )
            .join('\r\n')

        const blob = new Blob(['﻿' + csvContent], {
            type: 'text/csv;charset=utf-8;',
        })
        const link = document.createElement('a')
        link.setAttribute('href', URL.createObjectURL(blob))
        link.setAttribute('download', filename('csv', rows.length))
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    } finally {
        setIsLoading(false)
    }
}
